import { supabase } from './supabase'

/** When an invoice is fully paid, mark linked milestone as paid. */
export async function syncMilestonePaidForInvoice(invoiceId: string): Promise<void> {
  const { data: invoice } = await supabase
    .from('invoices')
    .select('id, balance_due, billing_milestone_id, status')
    .eq('id', invoiceId)
    .single()

  if (!invoice?.billing_milestone_id) return
  const balance = Number(invoice.balance_due ?? 0)
  const status = invoice.status
  if (balance > 0 && status !== 'paid') return

  await supabase
    .from('agreement_billing_milestones')
    .update({ status: 'paid', updated_at: new Date().toISOString() })
    .eq('id', invoice.billing_milestone_id)
    .eq('status', 'invoiced')
}
